import { createFileRoute } from '@tanstack/react-router';
import { ExperimentsPage } from './-experiments/ExperimentsPage';

/** @desc Experiments: prototypes for reviewers, each card explained (see `-experiments/registry`). */
export const Route = createFileRoute('/_protected/restricted/experiments')({
  component: ExperimentsPage,
});
